import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LeaveGuardService  {
    component: Object;
    route: ActivatedRouteSnapshot;

    constructor() {}

    canDeactivate(
        component: ILeaveComponent,
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
        nextState: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        return component && component.canExit ? component.canExit() : true;
    }
}

export interface ILeaveComponent {
    canExit: () => Observable<boolean> | Promise<boolean> | boolean;
}
